import { render, staticRenderFns } from "./invitationEdit.vue?vue&type=template&id=66ff1ec7&"
import script from "./invitationEdit.vue?vue&type=script&lang=js&"
export * from "./invitationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports